class UploadFeedCtrl {

    constructor($scope, $uibModalInstance) {
        $scope.ok = this.ok.bind(this);
        $scope.cancel = this.cancel.bind(this);

        this.$uibModalInstance = $uibModalInstance;
    }

    ok(file) {
        this.$uibModalInstance.close(file);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module('cpm')
    .controller('UploadFeedCtrl', ['$scope', '$uibModalInstance', UploadFeedCtrl]);
